import React, { Component } from 'react';
import ApiService from '../../service/ApiService';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Form, InputGroup } from 'react-bootstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';
import MediaQuery from 'react-responsive';

let searchInputValue = '';

const options = {
    sizePerPage: 20,
    hideSizePerPage: true,
};

const MySearch = (props) => {
    let input;
    const handleClick = () => {
        props.onSearch(input.value);
        searchInputValue = input.value;
    };
    return (
        <div>
            <InputGroup size="sm" className="mb-3">
                <Form.Control size="sm" type="text" placeholder="Search" value={searchInputValue} onChange={handleClick} ref={n => input = n} />
            </InputGroup>
        </div>
    );
};

const mobileColumns = [
    {
        dataField: "date",
        text: "Date",
        sort: true,
        headerStyle: { fontSize: '10px' },
    },
    {
        dataField: "event",
        text: "Event",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }    
    },    
    {
        dataField: "previous",
        text: "Prior",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }        
    },
    {
        dataField: "estimate",
        text: "Estimate",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }         
    },
    {
        dataField: "actual",
        text: "Actual",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }         
    },
];

const columns = [
    {
        dataField: "date",
        text: "Date",
        sort: true,
        headerStyle: { fontSize: '10px' },
    },
    {
        dataField: "event",
        text: "Event",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }    
    },      
    {
        dataField: "country",
        text: "Country",
        sort: true,
        headerStyle: { fontSize: '10px' },
        // style: (cell, row, rowIndex, colIndex) => {
        //     return {
        //         textAlign: 'left'
        //     }
        // }
    },
    {
        dataField: "previous",
        text: "Prior",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }        
    },
    {
        dataField: "estimate",
        text: "Estimate",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }         
    },
    {
        dataField: "actual",
        text: "Actual",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }         
    },
    {
        dataField: "change",
        text: "Change",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }         
    },
    {
        dataField: "changePercentage",
        text: "Change(%)",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }         
    },
];

const rowStyle = (row, rowIndex) => {
    const style = {};
    style.fontSize = '10px';
    // style.textAlign = 'left';
    return style;
};


class EconomicCalenderListDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            earningCalenderList: [],
            columns: columns,
            mobileColumns: mobileColumns,
            searchInputValue: '',
            limit: this.props.limit
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getData();
    }

    getData() {
        ApiService.getEconomicCalender(30)  //Get it for 30 days
            .then(result => {
                console.log('Earning Calender', result);
                if (result !== undefined && result.length > 0){
                    result.sort(this.custom_sort);
                    this.setState({ earningCalenderList: result });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    custom_sort(a, b) {
		return new Date(a.date).getTime() - new Date(b.date).getTime();
	}

    render() {
        return (
            <>
                <MediaQuery minWidth={501}>
                    <ToolkitProvider
                        keyField="symbol"
                        data={this.state.earningCalenderList}
                        columns={this.state.columns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>
                                    <MySearch {...props.searchProps} />
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        striped
                                        hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>

                <MediaQuery maxWidth={500}>
                    <ToolkitProvider
                        keyField="symbol"
                        data={this.state.earningCalenderList}
                        columns={this.state.mobileColumns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>
                                    <MySearch {...props.searchProps} />
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        striped
                                        hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>
            </>
        );
    }
}

export default EconomicCalenderListDisplay;
